// Module
var code = "<div class=\"text-emit-bubble\" @click=\"onGetTextClick()\" title=\"Add Keyword (Ctrl+Space)\" tabindex=\"-1\" :style=\"`left: ${data.menu.left}px; bottom: ${data.menu.bottom}px;`\" :class=\"{ 'is-active': menu.isActive, hidden: !showBubble }\"> <AddIcon class=\"icon\"></AddIcon> </div>";
// Exports
module.exports = code;